window.addEventListener('load', function() {
  document.querySelectorAll('.auth-button-holder a')
    .forEach(function(a) {
      a.addEventListener('click', function(e) {
        e.preventDefault();
        fbq('track', 'Lead', {
          content_category: 'registration',
          content_name: 'register_learn',
          product_group: '2j2rqtosqs'
        });
        window.location.href = a.href;
      });
    });
});